import { TRANSITION_MS, transitionCss } from '@/constants/timing';
import React from 'react';
import { Link } from 'react-router';
import { Typography } from '@mui/material';
import { CSSProperties } from 'react';
import { TypographyProps } from '@mui/material';
// import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";

export interface StyledLinkProps {
  variant?: TypographyProps['variant'];
  onClick?: () => void;
  to?: string;
  text: string;
  showUnderline?: boolean;
}

export const StyledLink: React.FC<StyledLinkProps> = ({
  to,
  onClick,
  text,
  variant,
  showUnderline = true,
}) => {
  const commonProps: { style: CSSProperties } = {
    style: {
      textDecoration: 'none',
      color: 'inherit',
      position: 'relative' as const,
      display: 'inline-block',
      cursor: 'pointer',
    },
  };

  const sxForLink = {
    color: 'text.primary',
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '1px',
      bottom: 0,
      left: 0,
      backgroundColor: 'currentColor',
      opacity: 0,
      transition: transitionCss({
        durationMs: TRANSITION_MS.DEFAULT,
        property: 'opacity',
      }),
    },
    '&:hover::after': showUnderline
      ? {
          opacity: 0.5,
        }
      : {},
  };
  const sxForSpan = {
    fontWeight: 600,
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '1px',
      bottom: 0,
      left: 0,
      backgroundColor: 'currentColor',
      opacity: 0,
      transition: transitionCss({
        durationMs: TRANSITION_MS.DEFAULT,
        property: 'opacity',
      }),
    },
    '&:hover::after': showUnderline
      ? {
          opacity: 0.5,
        }
      : {},
  };

  const content = (
    <Typography
      variant={variant || 'body2'}
      sx={to ? sxForLink : sxForSpan}
    >
      {text}
    </Typography>
  );

  return to ? (
    <Link
      to={to}
      {...commonProps}
    >
      {content}
    </Link>
  ) : (
    <span
      onClick={onClick}
      {...commonProps}
    >
      {content}
    </span>
  );
};
